import { useTranslation } from 'react-i18next';
import { Badge } from '@/shared/components/ui/badge';
import { cn } from '@/core/lib/utils';
import type { FormStatus } from '../../types';

const STATUS_CLASSES: Record<FormStatus, string> = {
  Draft: 'bg-gray-200 text-gray-700 hover:bg-gray-200',
  Shared: 'bg-green-100 text-green-700 hover:bg-green-100',
  Closed: 'bg-orange-100 text-orange-700 hover:bg-orange-100',
  Archived: 'bg-red-100 text-red-700 hover:bg-red-100',
};

const STATUS_KEYS: Record<FormStatus, string> = {
  Draft: 'status.draft',
  Shared: 'status.shared',
  Closed: 'status.closed',
  Archived: 'status.archived',
};

interface FormStatusBadgeProps {
  status: FormStatus;
}

export function FormStatusBadge({ status }: FormStatusBadgeProps) {
  const { t } = useTranslation('forms');

  return (
    <Badge
      className={cn('font-medium', STATUS_CLASSES[status])}
      data-testid={`forms-status-badge-${status.toLowerCase()}`}
    >
      {t(STATUS_KEYS[status])}
    </Badge>
  );
}
